import { ColumnDataType } from "@cotecna/tables";

export const EVENTS_TABLE_COLUMNS = [
  {
    dataProperty: "name",
    isSorting: true,
    label: "Event",
    dataType: ColumnDataType.String,
    width: 0,
  },
  {
    dataProperty: "startDateToShow",
    isSorting: true,
    label: "Start Date & Time",
    dataType: ColumnDataType.String,
    width: 0,
  },
  {
    dataProperty: "endDateToShow",
    isSorting: true,
    label: "End Date & Time",
    dataType: ColumnDataType.String,
    width: 0,
  },
  {
    dataProperty: "itemName",
    isSorting: true,
    label: "Item",
    dataType: ColumnDataType.String,
    width: 0,
  },
  {
    dataProperty: "createdBy",
    isSorting: true,
    label: "Created by",
    dataType: ColumnDataType.String,
    width: 0,
  },
  {
    dataProperty: "printReport",
    isSorting: true,
    label: "In Report",
    dataType: ColumnDataType.String,
    width: 0,
  },
  {
    dataProperty: "remarks",
    isSorting: true,
    label: "Remarks",
    dataType: ColumnDataType.String,
    width: 0,
    maxVisibleChars: 10,
  },
  {
    dataProperty: "shared",
    isSorting: false,
    label: "Shared",
    dataType: ColumnDataType.Toggle,
    width: 0,
  },
];
